<script>
    import { dbClearAllInvalidItems, clearAllInvalidItems, invalidateItem,user_data, parseCityStateZip } from './stores.js';
    import * as yup from 'yup'; 
    import { debounce } from 'lodash';
    import { onMount } from "svelte";
    import Iqtemplate from "./components/iqtemplate.svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";

    let purchase_price = "";
    let loan_balance = "";

    let purchase_price_element;
    let loan_balance_element;

    const formSchema = yup.object().shape({
        purchase_price_element: yup
        .number()
        .required('The home value is required to find the best rates.')
        .typeError('The home value must be a number'),
        loan_balance_element: yup
        .number()
        .typeError('The current balance must be a number')
        .required('The current balance is required to find the best rates.'),

    });
    async function checkNext() {
        clearAllInvalidItems();
        let res = false;
        await formSchema.validate({ 
            purchase_price_element: purchase_price_element.value.replace(/[^\d.-]/g, '').trim(),
            loan_balance_element: loan_balance_element.value.replace(/[^\d.-]/g, '').trim(),
        }).then(function (value) {
            res = true;
        }).catch(function (err) {
                invalidateItem(eval(err.path), err.errors[0]);
            res = false;
        });

        // check pp ratio limit
        if(res){
            let pp = parseInt(purchase_price.toString().replace(/[^\d.-]/g, ''));
            let lb = parseInt(loan_balance.toString().replace(/[^\d.-]/g, ''));
            
            if(isNaN(pp)){
                pp = 0;
            }
            if(isNaN(lb)){
                lb = 0;
            }

            if((lb/pp) <= 0.8 ){
                res = true;
            }else{
                invalidateItem(purchase_price_element, 'Your existing loan balance must be 80% or less than the value of the property.');
                res = false;
            }
        }

        // check previous loan limit
        if(res){
            let pp = parseInt(purchase_price.toString().replace(/[^\d.-]/g, ''));
            let lb = parseInt(loan_balance.toString().replace(/[^\d.-]/g, ''));
            
            if(isNaN(pp)){
                pp = 0;
            }
            if(isNaN(lb)){
                lb = 0;
            }


            if((lb) >= 50000 && (lb) <= 2000000){
                res = true;
            }else{
                invalidateItem(purchase_price_element, 'The existing loan balance must be between $50,000 and $2,000,000');
                res = false;
            }
        }

        return res;
    }

    function clearFunction() {
        dbClearAllInvalidItems();
    }

    $: {
        if(purchase_price !== "") $user_data.propertyvalue = purchase_price;
    }

    $: {
        if(loan_balance !== "") $user_data.currentbalance = loan_balance;
    }


    function formatEverything(){
        dbClearAllInvalidItems();
        const tpp = purchase_price.toString().replace(/[^\d.-]/g, '').trim();
        const tcb = loan_balance.toString().replace(/[^\d.-]/g, '').trim();
;

        if(tpp.length > 0){
            purchase_price = `$${tpp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        }

        if(tcb.length > 0){
            loan_balance = `$${tcb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        }

    }

    onMount(async () => {
        setTimeout(() => {
            if($user_data.propertyvalue !== ""){
                purchase_price = $user_data.propertyvalue;
                // purchase_price_element.value = $user_data.purchaseprice;
            }
            if($user_data.currentbalance !== ""){
                loan_balance = $user_data.currentbalance;
            }
            if(purchase_price_element.value !== ""){
                debouncedPurchasePriceChanged();
                debouncedCurrentBalanceChanged();
                formatEverything();
            }

        }, 200);

    });


    let debouncedPurchasePriceChanged = debounce(purchasePriceChanged, 100);
    let debouncedCurrentBalanceChanged = debounce(currentBalanceChanged, 100);
    let debouncedFormatter = debounce(formatEverything, 100);

    function purchasePriceChanged() {
        debouncedFormatter();
    }
    function currentBalanceChanged(){
        debouncedFormatter();
    }


</script>

<Iqtemplate
progress_mobile_version={true}
>
    <Progresscomponent 
    pre_next_callback_function={checkNext}
    title="What's the estimated value of your home and your current balance?"
    >
    <div class="pricedpcontainer">
        <div class="commentcontainer">
            Your loan amount can affect your loan progrem and rate.
        </div>
        <div class="purchasepricecontainer">
            <input on:keyup={()=>{debouncedPurchasePriceChanged();}} bind:this={purchase_price_element} bind:value={purchase_price} class="progressforminput" type="text" placeholder="Home Value" />
        </div>
        <div class="purchasepricecontainer">
            <div class="lbppricecontainer">
                <input on:keyup={()=>{debouncedCurrentBalanceChanged();}} bind:this={loan_balance_element} bind:value={loan_balance} class="progressforminput" type="text" placeholder="Loan Balance" />
            </div>
        </div>
    </div>
    </Progresscomponent>

</Iqtemplate>

<style>
.pricedpcontainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.commentcontainer {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    /* margin-bottom: 20px; */
    color: var(--blueslate);
    font-size: 1em;
}

.purchasepricecontainer {
    width: 40%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
}
.purchasepricecontainer input {
    width: 100%;
}

@media (max-device-width: 1024px), (max-width: 1023px) {
    .pricedpcontainer {
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        box-sizing: border-box;
    }
    .purchasepricecontainer{
        width: 100%;
    }
    .purchasepricecontainer input {
        width: 95% !important;
    }
}
</style>